export const UTM_TRACKING_KEY = 'alle-utm-json';
export const PENDING_TRANSACTION_MESSAGE_CLOSE_DATE =
  'pending-transaction-message-close-date';
